import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { NAV } from "@/lib/constants";

export default function Footer() {
  const { t, lang } = useI18n();
  return (
    <footer data-testid="site-footer" className="border-t border-neutral-300 bg-[#F7F7F6]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L21 7V17L12 22L3 17V7L12 2Z" stroke="#111" strokeWidth="1.4" />
              <path d="M12 12L21 7M12 12L3 7M12 12V22" stroke="#111" strokeWidth="1.2" />
            </svg>
            <span className="font-serif-display text-3xl">Peptivance</span>
          </div>
          <p className="mt-6 text-neutral-600 max-w-md">{t("footer_tag")}</p>
          <p className="mt-8 font-mono-label text-[10px] text-neutral-500">
            {t("legal_disclaimer")}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono-label text-[10px] text-neutral-500 mb-4">{t("footer_navigate")}</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.key}>
                <Link to={n.to} className="text-black hover:underline underline-offset-4">
                  {t(`nav_${n.key}`)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono-label text-[10px] text-neutral-500 mb-4">{t("footer_legal")}</p>
          <ul className="space-y-3">
            <li><Link to="/disclaimer" className="text-black hover:underline underline-offset-4">{t("footer_disclaimer")}</Link></li>
            <li><Link to="/terms" className="text-black hover:underline underline-offset-4">{t("footer_terms")}</Link></li>
            <li><Link to="/privacy" className="text-black hover:underline underline-offset-4">{t("footer_privacy")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-300">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-4 flex flex-col md:flex-row justify-between font-mono-label text-[10px] text-neutral-500">
          <span>© {new Date().getFullYear()} PEPTIVANCE — NETHERLANDS</span>
          <span>PEPTIVANCE.EU</span>
        </div>
      </div>
    </footer>
  );
}
